import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
/* eslint-disable @typescript-eslint/no-explicit-any */

import { appendErrors } from 'react-hook-form-v7';
import { toNestErrors } from "./toNestErrors";
import { validateFieldsNatively } from "./validateFieldsNatively";
var isZodError = function isZodError(error) {
  return error.errors != null;
};
var parseErrorSchema = function parseErrorSchema(zodErrors, validateAllFieldCriteria) {
  var errors = {};
  for (; zodErrors.length;) {
    var error = zodErrors[0];
    var code = error.code,
      message = error.message,
      path = error.path;
    var _path = path.join('.');
    if (!errors[_path]) {
      if ('unionErrors' in error) {
        var unionError = error.unionErrors[0].errors[0];
        errors[_path] = {
          message: unionError.message,
          type: unionError.code
        };
      } else {
        errors[_path] = {
          message: message,
          type: code
        };
      }
    }
    if ('unionErrors' in error) {
      error.unionErrors.forEach(function (unionError) {
        return unionError.errors.forEach(function (e) {
          return zodErrors.push(e);
        });
      });
    }
    if (validateAllFieldCriteria) {
      var types = errors[_path].types;
      var messages = types && types[error.code];
      errors[_path] = appendErrors(_path, validateAllFieldCriteria, errors, code, messages ? [].concat(messages, error.message) : error.message);
    }
    zodErrors.shift();
  }
  return errors;
};
export var zodResolver = function zodResolver(schema, schemaOptions) {
  var resolverOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, _, options) {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return schema[resolverOptions.mode === 'sync' ? 'parse' : 'parseAsync'](values, schemaOptions);
          case 3:
            data = _context.sent;
            options.shouldUseNativeValidation && validateFieldsNatively({}, options);
            return _context.abrupt("return", {
              errors: {},
              values: resolverOptions.raw ? values : data
            });
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            if (!isZodError(_context.t0)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", {
              values: {},
              errors: toNestErrors(parseErrorSchema(_context.t0.errors, !options.shouldUseNativeValidation && options.criteriaMode === 'all'), options)
            });
          case 12:
            throw _context.t0;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};